import { Field, FormikProps } from 'formik';
import { FormValues } from './remote-access.form-tools';
import { SwitchField } from 'shared/ui/formik-fields/switch-field';
import { TextField } from 'formik-mui';
import { UserPickerField } from '../user-picker';
import { Stack } from '@mui/material';

type Props = FormikProps<FormValues> & { withManager?: boolean };
export const RemoteAccessFormFields = ({ withManager = false }: Props ) => {

  return(
    <>
      <Stack direction="column" gap={1}>
        {withManager && <Field
          label="Менеджер"
          name='id'
          component={UserPickerField} /> }
        <Field
          label="Удаленный доступ"
          name='remoteAccess'
          type='checkbox'
          component={SwitchField}  
        /> 
        <Field
          label='IP'
          name='remoteAccessIP'
          component={TextField} />
      </Stack>
    </>
  );
};
